import { InjectionToken } from '@angular/core';
import { SignalrConfig } from './signalr.types';

export const SIGNALR_CONFIG_TOKEN = new InjectionToken<SignalrConfig>(
  'SIGNALR_CONFIG_TOKEN',
);
